module.exports = __webpack_public_path__ + "pcsg/img/productlist-00.a27c7f07.jpg";